import { composeSelectors } from "seneca-common/utils/selectors/compose-selectors";

import ContentStatsStateSlice from "../../../models/state/contentStats";
import * as metaSelectors from "./meta";
import * as statsSelectors from "./stats";
import { ContentStatsMetaSelectors, ContentStatsSelectors } from "./types";

type State = ContentStatsStateSlice;

function getContentStatsStatsState(state: State) {
  //TODO: update model to be a record and get rid of 'get'
  return state.get("stats");
}

function getContentStatsMetaState(state: State) {
  return state.get("meta");
}

// @ts-ignore
export const {
  allContentStatsForCourseFetching,
  allContentStatsForCourseFetchSucceeded,
  allContentStatsForCourseFetchErrored,
  allContentStatsForCourseFetchFinished,
  allContentStatsForCourseNeedsFetching
}: ContentStatsMetaSelectors<State> = composeSelectors(
  // @ts-ignore
  getContentStatsMetaState,
  metaSelectors
);

// @ts-ignore
export const {
  getId,
  getTimesStudied,
  getLastStudied,
  getLastScore,
  getLastContentModuleId,
  getContentStat,
  lastTryWasIncorrect,
  getContentStats,
  hasContentStat
}: ContentStatsSelectors<State> = composeSelectors(
  // @ts-ignore
  getContentStatsStatsState,
  statsSelectors
);
